import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import assignments from './assignments';
import auth from './auth';
import bingo from './bingo';
// import cart from './cart';
import categories from './categories';
import customers from './customers';
import deals from './deals';
import distributes from './distributes';
import favorites from './favorites';
import giveaway from './giveaway';
import initialData from './initialData';
import media from './media';
import messages from './messages';
import modules from './modules';
import offer from './offer';
import orderDeals from './orderDeals';
import orderPackages from './orderPackages';
import orderProducts from './orderProducts';
import orders from './orders';
import packages from './packages';
import partner from './partner';
import partnerUser from './partnerUser';
import perks from './perks';
import points from './points';
import progressTracker from './progressTracker';
import products from './products';
import tickets from './tickets';
import unregisteredData from './unregisteredData';
import userLocation from './userLocation';
import venues from './venues';

// cart sub-modules
import cartAssignments from './cart/assignments';
import cartCustomer from './cart/customer';
import cartDeals from './cart/deals';
import cartDistribute from './cart/distribute';
import cartModules from './cart/modules';
import cartOrders from './cart/orders';
import cartOrderDeals from './cart/orderDeals';
import cartOrderPackages from './cart/orderPackages';
import cartOrderProducts from './cart/orderProducts';
import cartPackages from './cart/packages';
import cartProducts from './cart/products';

// Persisted store key
const { searchParams } = new URL(window.location.href);
const token = searchParams.get('t') || 'NO-TOKEN';

const store = createStore({
  strict: true,

  modules: {
    assignments,
    auth,
    bingo,

    cart: {
      modules: {
        cartAssignments,
        cartCustomer,
        cartDeals,
        cartDistribute,
        cartModules,
        cartOrders,
        cartOrderDeals,
        cartOrderPackages,
        cartOrderProducts,
        cartPackages,
        cartProducts
      }
    },

    categories,
    customers,
    deals,
    distributes,
    favorites,
    giveaway,
    initialData,
    media,
    messages,
    modules,
    offer,
    orderDeals,
    orderPackages,
    orderProducts,
    orders,
    packages,
    partner,
    partnerUser,
    perks,
    points,
    progressTracker,
    products,
    tickets,
    unregisteredData,
    userLocation,
    venues
  },

  plugins: [
    createPersistedState({
      key: `vuex-${token}`,
      storage: window.sessionStorage,
      paths: ['orders', 'cart']
    })
  ]
});

export default store;
